export const MOCK_META_GRAPH_INFLUENCERS = [
  {
    companyNo: 10001,
    platform: 'INSTAGRAM',
    graph: {
      id: '17841470000000001',
      username: 'travel.jieun',
      name: '이지은',
      profile_picture_url: 'https://images.unsplash.com/photo-1544005313-94ddf0286df2?auto=format&fit=facearea&w=256&h=256&q=80',
      biography: '국내/해외 자유여행 · 숙소/맛집 리뷰 · 여행 동선 공유',
      website: 'https://example.com/travel-jieun',
      followers_count: 128400,
      follows_count: 412,
      media_count: 682
    },
    insights: {
      engagement_rate: 0.034,
      avg_likes: 3820,
      avg_comments: 96,
      avg_reach: 54100,
      avg_impressions: 89100,
      audience: {
        top_countries: [
          { country: 'KR', share: 0.86 },
          { country: 'JP', share: 0.06 },
          { country: 'US', share: 0.03 }
        ],
        gender_age: [
          { gender: 'F', age: '18-24', share: 0.18 },
          { gender: 'F', age: '25-34', share: 0.41 },
          { gender: 'M', age: '25-34', share: 0.15 },
          { gender: 'F', age: '35-44', share: 0.14 }
        ]
      },
      recent_media: [
        {
          id: '179000000000001',
          media_type: 'REELS',
          permalink: 'https://instagram.com/reel/CXxxxx001',
          timestamp: '2026-02-12T09:00:00+0000',
          caption: '오사카 2박3일 동선 요약! 교토 당일치기 포함'
        },
        {
          id: '179000000000002',
          media_type: 'IMAGE',
          permalink: 'https://instagram.com/p/CXxxxx002',
          timestamp: '2026-02-05T09:00:00+0000',
          caption: '제주 애월 숙소 추천 · 조식이 미쳤다'
        },
        {
          id: '179000000000003',
          media_type: 'CAROUSEL',
          permalink: 'https://instagram.com/p/CXxxxx003',
          timestamp: '2026-01-28T09:00:00+0000',
          caption: '홍콩 야경 스팟 5곳 (지도 공유)'
        }
      ]
    },
    tags: {
      categories: ['TRAVEL', 'HOTEL', 'FOOD'],
      brand_safety: 'GREEN',
      language: 'ko'
    }
  },
  {
    companyNo: 10002,
    platform: 'INSTAGRAM',
    graph: {
      id: '17841470000000002',
      username: 'daily.foodlab',
      name: '김도윤',
      profile_picture_url: 'https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?auto=format&fit=facearea&w=256&h=256&q=80',
      biography: '서울/경기 맛집 · 신상 카페 · 가성비 코스',
      website: 'https://example.com/daily-foodlab',
      followers_count: 56300,
      follows_count: 988,
      media_count: 1214
    },
    insights: {
      engagement_rate: 0.052,
      avg_likes: 2510,
      avg_comments: 68,
      avg_reach: 28700,
      avg_impressions: 46200,
      audience: {
        top_countries: [
          { country: 'KR', share: 0.93 },
          { country: 'VN', share: 0.02 },
          { country: 'TH', share: 0.02 }
        ],
        gender_age: [
          { gender: 'F', age: '18-24', share: 0.22 },
          { gender: 'F', age: '25-34', share: 0.37 },
          { gender: 'M', age: '18-24', share: 0.12 },
          { gender: 'M', age: '25-34', share: 0.17 }
        ]
      },
      recent_media: [
        {
          id: '179000000000011',
          media_type: 'REELS',
          permalink: 'https://instagram.com/reel/CXxxxx011',
          timestamp: '2026-02-14T09:00:00+0000',
          caption: '강남 점심 1만원 코스 3곳'
        },
        {
          id: '179000000000012',
          media_type: 'IMAGE',
          permalink: 'https://instagram.com/p/CXxxxx012',
          timestamp: '2026-02-07T09:00:00+0000',
          caption: '성수 신상 카페 · 디저트가 진짜'
        },
        {
          id: '179000000000013',
          media_type: 'CAROUSEL',
          permalink: 'https://instagram.com/p/CXxxxx013',
          timestamp: '2026-01-30T09:00:00+0000',
          caption: '잠실 데이트 코스: 맛집→카페→야경'
        }
      ]
    },
    tags: {
      categories: ['FOOD', 'CAFE', 'LIFESTYLE'],
      brand_safety: 'GREEN',
      language: 'ko'
    }
  },
  {
    companyNo: 10003,
    platform: 'INSTAGRAM',
    graph: {
      id: '17841470000000003',
      username: 'family.weekend',
      name: '박소연',
      profile_picture_url: 'https://images.unsplash.com/photo-1550525811-e5869dd03032?auto=format&fit=facearea&w=256&h=256&q=80',
      biography: '아이와 주말 나들이 · 키즈프렌들리 숙소/여행',
      website: 'https://example.com/family-weekend',
      followers_count: 21400,
      follows_count: 633,
      media_count: 842
    },
    insights: {
      engagement_rate: 0.041,
      avg_likes: 760,
      avg_comments: 31,
      avg_reach: 10600,
      avg_impressions: 17400,
      audience: {
        top_countries: [
          { country: 'KR', share: 0.95 },
          { country: 'US', share: 0.02 },
          { country: 'JP', share: 0.01 }
        ],
        gender_age: [
          { gender: 'F', age: '25-34', share: 0.34 },
          { gender: 'F', age: '35-44', share: 0.29 },
          { gender: 'M', age: '25-34', share: 0.13 },
          { gender: 'M', age: '35-44', share: 0.12 }
        ]
      },
      recent_media: [
        {
          id: '179000000000021',
          media_type: 'REELS',
          permalink: 'https://instagram.com/reel/CXxxxx021',
          timestamp: '2026-02-16T09:00:00+0000',
          caption: '유아동반 리조트 체크리스트 10'
        },
        {
          id: '179000000000022',
          media_type: 'IMAGE',
          permalink: 'https://instagram.com/p/CXxxxx022',
          timestamp: '2026-02-08T09:00:00+0000',
          caption: '키즈풀 있는 호텔 추천'
        },
        {
          id: '179000000000023',
          media_type: 'CAROUSEL',
          permalink: 'https://instagram.com/p/CXxxxx023',
          timestamp: '2026-02-01T09:00:00+0000',
          caption: '주말 근교 나들이 TOP 5'
        }
      ]
    },
    tags: {
      categories: ['FAMILY', 'TRAVEL', 'HOTEL'],
      brand_safety: 'GREEN',
      language: 'ko'
    }
  }
];

export const formatCompactNumber = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '-';
  try {
    return new Intl.NumberFormat('ko-KR', { notation: 'compact', maximumFractionDigits: 1 }).format(n);
  } catch {
    return n.toLocaleString('ko-KR');
  }
};

export const formatPercent = (value, digits = 1) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return '-';
  const p = n * 100;
  return `${p.toFixed(digits)}%`;
};

export const getMockMetaInfluencerByCompanyNo = (companyNo) => {
  const no = Number(companyNo);
  if (!Number.isFinite(no) || no <= 0) return null;

  const list = Array.isArray(MOCK_META_GRAPH_INFLUENCERS) ? MOCK_META_GRAPH_INFLUENCERS : [];
  if (list.length === 0) return null;

  const direct = list.find((x) => Number(x.companyNo) === no) || null;
  if (direct) return direct;

  // fallback: pick a stable sample so UI can still display something
  const idx = Math.abs(Math.trunc(no)) % list.length;
  return list[idx] || list[0] || null;
};

export const getMockMetaInfluencerSummaryByCompanyNo = (companyNo) => {
  const item = getMockMetaInfluencerByCompanyNo(companyNo);
  if (!item) return null;
  return {
    companyNo: item.companyNo,
    platform: item.platform,
    username: item.graph?.username,
    name: item.graph?.name,
    profilePictureUrl: item.graph?.profile_picture_url,
    followersCount: item.graph?.followers_count,
    engagementRate: item.insights?.engagement_rate,
    categories: Array.isArray(item.tags?.categories) ? item.tags.categories : []
  };
};

export const getMockMetaInfluencerProfileByCompanyNo = (companyNo) => {
  const item = getMockMetaInfluencerByCompanyNo(companyNo);
  if (!item) return null;
  return {
    companyNo: item.companyNo,
    platform: item.platform,
    graph: item.graph,
    insights: item.insights,
    tags: item.tags
  };
};
